<script setup lang="ts">
// The VectorSurv integration's own index. Each of the four things a district
// configures for VectorSurv has its own page, so this one is navigation rather
// than a form: the connection credential, the users it files under, the
// district's equipment, and the synchronization itself.
import { useRouter } from "vue-router";

interface Page {
	name: string;
	description: string;
	icon: string;
	route: string;
}

const router = useRouter();

const pages: Page[] = [
	{
		name: "Connection",
		description:
			"The agency token this district files with, the agency its filings are attributed to, and a check that the credential works.",
		icon: "bi bi-plug",
		route: "/_/configuration/integration/vectorsurv/connection",
	},
	{
		name: "Users",
		description:
			"The organization's active users and which of them still need a VectorSurv user to file under.",
		icon: "bi bi-people",
		route: "/_/configuration/integration/vectorsurv/users",
	},
	{
		name: "Equipment",
		description:
			"The district's application equipment. A treatment files only when its equipment and applicator are captured against it, so this is what the filing pickers offer.",
		icon: "bi bi-truck",
		route: "/_/configuration/integration/vectorsurv/equipment",
	},
	{
		name: "Sync",
		description:
			"Whether filing is running, what has been sent and when, the ledger of every record that crossed the boundary with its content, and the inbound mirror.",
		icon: "bi bi-arrow-left-right",
		route: "/_/configuration/integration/vectorsurv/sync",
	},
];
</script>

<template>
	<div class="container py-4">
		<div class="d-flex justify-content-between align-items-center mb-4">
			<div class="d-flex align-items-center">
				<RouterLink
					class="btn btn-outline-secondary me-3"
					to="/_/configuration/integration"
					title="Back to integrations"
				>
					<i class="bi bi-arrow-left"></i>
				</RouterLink>
				<div>
					<h1 class="mb-0">VectorSurv</h1>
					<p class="text-muted mb-0">Configure the VectorSurv integration</p>
				</div>
			</div>
		</div>

		<div class="table-responsive">
			<table class="table table-hover align-middle">
				<thead class="table-light">
					<tr>
						<th style="width: 50px"></th>
						<th style="width: 200px">Page</th>
						<th>What it holds</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="page in pages"
						:key="page.name"
						class="page-row"
						@click="router.push(page.route)"
					>
						<td>
							<div class="page-icon">
								<i :class="page.icon"></i>
							</div>
						</td>
						<td class="fw-semibold">{{ page.name }}</td>
						<td class="text-muted small">{{ page.description }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<style scoped>
.page-row {
	cursor: pointer;
	transition: background-color 0.15s ease;
}
.page-row:hover {
	background-color: rgba(13, 110, 253, 0.05);
}
.page-icon {
	font-size: 1.5rem;
	width: 40px;
	text-align: center;
	color: #0d6efd;
}
</style>
